export default __webpack_public_path__ + "ec55c8a47e4b252c640248b0b8d00b1d.png";